import React from 'react';
import { SparklesIcon } from 'lucide-react';
import { ApplyButton } from './ApplyButton';
interface ScientificCredibilityBannerProps {
  onNavigate?: (sectionId: string) => void;
}
export function ScientificCredibilityBanner({
  onNavigate
}: ScientificCredibilityBannerProps) {
  const logos = [{
    name: 'PubMed',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fb/US-NLM-NCBI-Logo.svg/2560px-US-NLM-NCBI-Logo.svg.png'
  }, {
    name: 'NIH',
    url: 'https://upload.wikimedia.org/wikipedia/commons/thumb/5/53/NIH_Master_Logo_Vertical_2Color.svg/2560px-NIH_Master_Logo_Vertical_2Color.svg.png'
  }, {
    name: 'Nature',
    url: 'https://media.springernature.com/full/nature-cms/uploads/product/nature/header-86f1267ea01eccd46b530284be10585e.svg'
  }, {
    name: 'Science',
    url: 'https://www.science.org/pb-assets/images/logos/science-logo-1689000248960.svg'
  }, {
    name: 'The Lancet',
    url: 'https://marlin-prod.literatumonline.com/pb-assets/Lancet/tlancet/images/Lancet_Logo-1601555263539.svg'
  }, {
    name: 'Cell',
    url: 'https://www.cell.com/pb/assets/raw/shared/journal-logos/cell.svg'
  }, {
    name: 'JAMA',
    url: 'https://cdn.jamanetwork.com/images/logos/JAMA.png'
  }, {
    name: 'New England Journal of Medicine',
    url: 'https://www.nejm.org/pb-assets/images/logo-1593698569583.png'
  }];
  return <section className="relative py-20 overflow-hidden w-full" data-id="element-189">
      {/* Full-width gradient background */}
      <div className="absolute inset-0 bg-gradient-to-b from-slate-900/80 via-fuchsia-950/60 to-slate-900/80" data-id="element-190"></div>
      {/* Ambient lighting effects spanning full width */}
      <div className="absolute top-0 left-1/4 w-96 h-96 bg-cyan-500/15 rounded-full blur-3xl" data-id="element-191"></div>
      <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-fuchsia-500/15 rounded-full blur-3xl" data-id="element-192"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[400px] bg-gradient-to-r from-cyan-500/10 via-fuchsia-500/10 to-cyan-500/10 rounded-full blur-3xl" data-id="element-193"></div>
      {/* Content container */}
      <div className="max-w-6xl mx-auto px-6 relative" data-id="element-194">
        <div className="bg-slate-800/60 backdrop-blur-sm rounded-2xl shadow-2xl border border-fuchsia-500/30 p-10 relative overflow-hidden" data-id="element-195">
          <div className="absolute inset-0 bg-gradient-to-br from-cyan-500/5 to-fuchsia-500/5" data-id="element-196"></div>
          <div className="absolute top-0 left-0 w-64 h-64 bg-gradient-to-br from-cyan-500/10 to-transparent rounded-full blur-3xl" data-id="element-197"></div>
          <div className="absolute bottom-0 right-0 w-64 h-64 bg-gradient-to-tl from-fuchsia-500/10 to-transparent rounded-full blur-3xl" data-id="element-198"></div>
          <div className="relative" data-id="element-199">
            <div className="text-center mb-10" data-id="element-200">
              <h3 className="text-3xl md:text-4xl font-bold text-white mb-4 leading-tight" data-id="element-201">
                Our transformations are the result of deep commitment to
                scientific truth, accuracy and{' '}
                <span className="underline decoration-cyan-400 decoration-4 underline-offset-4" data-id="element-202">
                  precision
                </span>
                .
              </h3>
              <p className="text-lg text-cyan-100 font-medium max-w-3xl mx-auto" data-id="element-203">
                Drawing from thousands of peer-reviewed studies across the
                world's leading scientific institutions in new and innovative
                ways
              </p>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8 items-center justify-items-center" data-id="element-204">
              {logos.map((logo, index) => <div key={index} className="group relative" data-id="element-205">
                  <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 to-fuchsia-500/20 rounded-xl blur-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-206"></div>
                  <div className="relative bg-white/10 backdrop-blur-sm p-4 rounded-xl border border-white/20 hover:border-cyan-400/50 transition-all duration-300 hover:scale-105" data-id="element-207">
                    <img src={logo.url} alt={logo.name} className="h-12 w-auto object-contain filter brightness-0 invert opacity-80 group-hover:opacity-100 transition-opacity duration-300" data-id="element-208" />
                  </div>
                </div>)}
            </div>
          </div>
        </div>
        <div className="text-center mt-10" data-id="element-209">
          <ApplyButton text="Start Your Transformation" onNavigate={onNavigate} data-id="element-210" />
        </div>
      </div>
    </section>;
}